module.exports = __webpack_public_path__ + "static/img/princeton.f4c682c2.png";